<template>
    <CustomDialog :value="visible" @cancel="$emit('close')" @confirm="handleSave" :defaultTitle="title" width="600px">
        <template #content>
            <form @submit.prevent="handleSave" class="ppv2-flex ppv2-flex-col ppv2-gap-6 ppv2-px-2 ppv2-pt-4">
                <!-- Periods Section -->
                <div class="ppv2-flex ppv2-flex-col ppv2-gap-4">
                    <div
                        v-for="(period, idx) in localDayInfo.periods"
                        :key="'period-' + idx"
                        class="ppv2-flex ppv2-items-center ppv2-gap-3"
                    >
                        <div class="ppv2-flex ppv2-items-center ppv2-gap-2 ppv2-flex-1">
                            <BaseTimeInput
                                :id="`input-period-${idx}-start`"
                                v-model="localDayInfo.periods[idx].start"
                                :placeholder="'09:00'"
                                input-class="ppv2-flex-1"
                                :customSizeLabel="12"
                            />
                            <BaseTimeInput
                                :id="`input-period-${idx}-end`"
                                v-model="localDayInfo.periods[idx].end"
                                :placeholder="'18:00'"
                                input-class="ppv2-flex-1"
                                :customSizeLabel="12"
                            />
                        </div>
                        <div class="ppv2-flex ppv2-items-center">
                            <button
                                v-if="idx === 0"
                                type="button"
                                :disabled="localDayInfo.lunches.length > 0"
                                class="ppv2-ml-2 ppv2-px-3 ppv2-py-1 ppv2-bg-blue-100 ppv2-rounded-md hover:ppv2-bg-blue-200 ppv2-text-blue-600 poppinsBold disabled:ppv2-opacity-50 disabled:ppv2-cursor-not-allowed"
                                @click="addLunch"
                                title="Ajouter une pause"
                            >
                                +
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Single Lunch Section -->
                <div v-if="localDayInfo.lunches.length > 0" class="ppv2-flex ppv2-flex-col ppv2-gap-4">
                    <div v-for="(lunch, lunchInx) in localDayInfo.lunches" :key="'lunch-' + lunchInx">
                        <label class="ppv2-block ppv2-mb-2 ppv2-text-[#4b5563] poppinsMedium">{{
                            $t('resource_planning.lunch_break')
                        }}</label>
                        <div class="ppv2-flex ppv2-items-center ppv2-gap-3">
                            <div class="ppv2-flex ppv2-items-center ppv2-gap-2 ppv2-flex-1">
                                <BaseTimeInput
                                    id="input-lunch-start"
                                    v-model="localDayInfo.lunches[lunchInx].start"
                                    :placeholder="'12:00'"
                                    input-class="ppv2-flex-1"
                                    :customSizeLabel="12"
                                />
                                <BaseTimeInput
                                    id="input-lunch-end"
                                    v-model="localDayInfo.lunches[lunchInx].end"
                                    :placeholder="'13:00'"
                                    input-class="ppv2-flex-1"
                                    :customSizeLabel="12"
                                />
                            </div>
                            <div class="ppv2-flex ppv2-items-center">
                                <button
                                    type="button"
                                    class="ppv2-ml-2 ppv2-px-2 ppv2-py-1 ppv2-bg-red-100 ppv2-rounded-md hover:ppv2-bg-red-200 ppv2-text-red-500"
                                    @click="removeLunch(lunchInx)"
                                    title="Supprimer la pause"
                                >
                                    🗑️
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </template>
    </CustomDialog>
</template>

<script>
import BaseTimeInput from '../../Shared/BaseTimeInput.vue'
import CustomDialog from '../../Shared/CustomDialog.vue'

export default {
    name: 'EditPlanningDay',
    components: { BaseTimeInput, CustomDialog },
    props: {
        visible: { type: Boolean, default: false },
        title: { type: String, default: 'Éditer la journée' },
        dayInfo: {
            type: Object,
            default: () => ({
                periods: [{ start: '09:00', end: '18:00' }],
                lunches: [],
            }),
        },
    },
    data() {
        return {
            localDayInfo: {
                periods: [],
                lunches: [],
            },
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.localDayInfo = JSON.parse(JSON.stringify(this.dayInfo))
                if (!Array.isArray(this.localDayInfo.lunches)) {
                    this.localDayInfo.lunches = []
                }
            }
        },
    },
    methods: {
        addLunch() {
            if (this.localDayInfo.lunches.length == 0) {
                this.localDayInfo.lunches = [{ start: '12:00', end: '13:00' }]
            }
        },
        removeLunch(idx) {
            if (this.localDayInfo.lunches.length > 0) {
                this.localDayInfo.lunches.splice(idx, 1)
            }
        },
        handleSave() {
            // Clean up lunches if empty
            if (!this.localDayInfo.lunches.length || (!this.localDayInfo.lunches[0].start && !this.localDayInfo.lunches[0].end)) {
                this.localDayInfo.lunches = []
            }
            this.$emit('save', JSON.parse(JSON.stringify(this.localDayInfo)))
        },
    },
}
</script>

<style scoped></style>
